import request from '@/config'
import { useAppStoreWithOut } from '@/store/app'

/* Types */
import { SysModulesSearch, ModuleBase, ModuleCreate, ModuleEdit } from './modules.type';

const appStore = useAppStoreWithOut()

/* 系统模块：查询(LIST) */
export const GetModulesListApi = (searchIpt: SysModulesSearch = { page_size: 10, current: 1, tenant_id: 1 }): Promise<IResponse> => {
    return request.post({ url: '/api/SysModule/GetSysModulePage', data: searchIpt })
}

/* 系统模块：获取详细(Detail) */
export const ModDetailApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysModule/GetSysModuleInfo', data: delParams })
}

/* 系统模块：创建(CREATE) */
export const ModCreateApi = (createIpt: ModuleBase): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const creatInfo = {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
        created_user_id: login.user_id
    }

    const createData: ModuleCreate = Object.assign({}, creatInfo, createIpt)

    return request.post({ url: '/api/SysModule/InsertSysModule', data: createData })
}

/* 系统模块：修改(Modify) */
export const ModEditApi = (rowId: string, modifyIpt: ModuleBase): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo

    const modifyInfo = {
        curr_user_id: login.user_id,
        tenant_id: login.tenant_id,
        company_id: login.company_id,
        updated_user_id: login.user_id,
        id: rowId
    }

    const modifyData: ModuleEdit = Object.assign({}, modifyInfo, modifyIpt)

    return request.post({ url: ' /api/SysModule/UpdateSysModule', data: modifyData })
}

/* 系统模块：删除(Delete) */
export const ModDeleteApi = (rowId: string, revision: string): Promise<IResponse> => {

    const login = appStore.getLoginInfo as LoginInfo
    const delParams = {
        curr_user_id: login.user_id,
        company_id: login.company_id,
        deleted_user_id: login.user_id,
        tenant_id: login.tenant_id,
        revision: revision,
        id: rowId
    }

    return request.post({ url: '/api/SysModule/DeleteSysModule', data: delParams })
}

/* 系统模块：节点tree */
export const GetRtTreeApi = (): Promise<IResponse> => {
    return request.post({ url: '/api/sysmodule/getsysmoduletree', data: {} })
}

export const GetMenuApi = (): Promise<IResponse> => {
    return request.post({ url: '/api/sysmodule/getmenutree', data: {} })
}


